import { useCallback, useEffect, useMemo, useState } from "react";

import { useArticleRenderContext } from "~/components/article/article-render/contexts";
import { useArticleSpeechUtils } from "~/components/article/article-speech/article-speech-player/hooks";
import { useArticleSpeechContext } from "~/components/article/article-speech/contexts";
import { sendGATracking } from "~/components/tracking/google-analytics/apis";

/**
 *
 * @param oneTimeButton indicate the button can be clicked one time only
 * @returns
 */
export const useArticleSpeechButton = (oneTimeButton: boolean = false) => {
  const [isClickedCount, setIsClickedCount] = useState(0);
  const { articleSpeechifyPlayer } = useArticleSpeechContext();
  const { checkIsCurrentArticlePlaying } = useArticleSpeechUtils();
  const { articleElementReference } = useArticleRenderContext();

  const isClicked = useMemo(() => isClickedCount > 0, [isClickedCount]);
  const wrappedSetIsClicked = useCallback(() => {
    if (oneTimeButton && isClicked) return;
    sendGATracking({
      action: "TTS/Click",
      category: "TTS",
      label: "",
    });
    setIsClickedCount(isClickedCount => isClickedCount + 1);
  }, [isClicked, oneTimeButton]);

  useEffect(() => {
    if (
      isClickedCount === 0 ||
      !articleSpeechifyPlayer ||
      !checkIsCurrentArticlePlaying(articleElementReference?.current)
    )
      return;
    articleSpeechifyPlayer.play();
  }, [
    articleElementReference,
    articleSpeechifyPlayer,
    checkIsCurrentArticlePlaying,
    isClickedCount,
  ]);

  return {
    isClicked,
    setIsClicked: wrappedSetIsClicked,
  };
};
